
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button style="background-color: #174e6d!important;
  color: #ffffff !important" mat-raised-button (click)="onClose()">OK</button>
</mat-dialog-actions>
